import { createSlice } from '@reduxjs/toolkit'

import { Appliance, Input, InputGraph, LimitedAppliance, MetricWindow, ServiceOverview } from 'common/api/v1/types'
import {
  getService,
  clearService,
  selectTr101290Window,
  setEnableAnimations,
  LOCAL_STORAGE_SO_ANIMATION,
} from '../actions/serviceOverviewActions'
import { logoutUser } from '../actions/userActions'
import { createLoadingReducer } from './shared'

export interface ServiceOverviewState {
  input?: Input
  parent?: Input
  loading: boolean
  graph: InputGraph
  appliances: (Appliance | LimitedAppliance)[]
  tunnels: ServiceOverview['objects']['tunnels']
  outputs: ServiceOverview['objects']['outputs']
  derivedInputs: ServiceOverview['objects']['derivedInputs']
  tr101290Window: MetricWindow
  isAnimationEnabled: boolean
}
export const initialStateServiceOverview: ServiceOverviewState = {
  loading: false,
  graph: {
    nodes: {},
    edges: [],
  },
  appliances: [],
  tunnels: [],
  outputs: { items: [], total: 0 },
  derivedInputs: [],
  tr101290Window: MetricWindow.m1,
  isAnimationEnabled: localStorage.getItem(LOCAL_STORAGE_SO_ANIMATION) === 'enabled',
}

type State = ServiceOverviewState
const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(getService)

const serviceOverviewSlice = createSlice({
  name: 'serviceOverview',
  initialState: initialStateServiceOverview,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        getService.fulfilled,
        (
          state,
          {
            payload: {
              input,
              parent,
              graph,
              objects: { tunnels, appliances, outputs, derivedInputs },
            },
          },
        ) => ({
          ...state,
          input: input || state.input,
          parent: parent ?? undefined,
          graph,
          appliances,
          tunnels,
          outputs,
          derivedInputs,
        }),
      )
      .addCase(selectTr101290Window.pending, (state, { meta: { arg: tr101290Window } }) => ({
        ...state,
        tr101290Window,
      }))
      .addCase(clearService, (prevState) => ({
        ...initialStateServiceOverview,
        tr101290Window: prevState.tr101290Window,
        isAnimationEnabled: prevState.isAnimationEnabled,
      }))
      .addCase(logoutUser.fulfilled, () => initialStateServiceOverview)
      .addCase(setEnableAnimations, (state, { payload }): State => ({ ...state, isAnimationEnabled: payload }))
      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default serviceOverviewSlice.reducer
